export {default} from './Text';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/Text/index.ts